module.exports = __webpack_public_path__ + "assets/granngarden-logo.1d570711.svg";